/**
 * FERP Portal - Constraint List Page (DRR-074: Tabulator DRY Template)
 *
 * CONFIGURE Phase: Limits, quotas, and guardrails governing workflow execution.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function ConstraintListPage() {
  return <TabulatorPrimitiveManager primitiveType="constraint" />;
}

export default ConstraintListPage;
